// @flow
import moment from 'moment';

export const isValidDateString = (dateStr: ?string): boolean => {
  if (dateStr == null) return true; // null/undefined are not "invalid input"
  if (dateStr === '') return false; // empty string means user entered an invalid date
  return moment(dateStr, 'YYYY-MM-DD', true).isValid();
};

export const isEndDateBeforeStartDate = (
  startDate: ?string,
  endDate: ?string,
): boolean => {
  if (startDate == null || endDate == null) return false;
  if (!isValidDateString(startDate) || !isValidDateString(endDate))
    return false;
  return moment(endDate, 'YYYY-MM-DD').isBefore(
    moment(startDate, 'YYYY-MM-DD'),
  );
};

export const hasInvalidAdmissionDates = (
  programAdmissions: Array<{start_date: ?string, end_date: ?string}>,
  groupAdmissions: Array<{start_date: ?string, end_date: ?string}>,
): boolean => {
  const isInvalidAdmission = (adm) =>
    (adm.start_date !== null && !isValidDateString(adm.start_date)) ||
    (adm.end_date !== null && !isValidDateString(adm.end_date)) ||
    isEndDateBeforeStartDate(adm.start_date, adm.end_date);
  const invalidProgram = programAdmissions.some(isInvalidAdmission);
  const invalidGroup = groupAdmissions.some(isInvalidAdmission);
  return invalidProgram || invalidGroup;
};
